<app-confirm-dialog
  [visible]="true"
  [title]="'testPlans.form.selectionChange.title' | translate"
  message=""
  titleId="tp-change-selection-title"
  [confirmLabel]="'testPlans.form.selectionChange.confirm' | translate"
  [cancelLabel]="'testPlans.form.cancel' | translate"
  confirmTestId="tp-change-selection-confirm"
  [busy]="loading()"
  [confirmColor]="danger() ? 'warn' : 'primary'"
  [iconTon]="danger() ? 'gefahr' : 'akzent'"
  [icon]="danger() ? 'delete' : 'edit'"
  (confirmed)="confirmed.emit()"
  (cancelled)="cancelled.emit()"
>
  <div class="scd-content">
    <div class="scd-delta" data-testid="tp-change-selection-delta">
      @if (added().length > 0) {
        <div>
          <b class="scd-delta__added">
            {{ 'testPlans.form.selectionChange.added' | translate: { count: added().length } }}
          </b>
          <span class="scd-delta__ids">{{ added().join(', ') }}</span>
        </div>
      }
      @if (removed().length > 0) {
        <div>
          <b class="scd-delta__removed">
            {{ 'testPlans.form.selectionChange.removed' | translate: { count: removed().length } }}
          </b>
          <span class="scd-delta__ids">{{ removed().join(', ') }}</span>
        </div>
      }
    </div>

    @if (loadFailed()) {
      <div class="scd-text--warn" role="alert">{{ 'testPlans.form.selectionChange.runsLoadError' | translate }}</div>
    } @else if (!loading()) {
      @if (countedRuns() > 0) {
        @if (removed().length > 0) {
          <div>
            @if (countedRuns() === 1) {
              {{ 'testPlans.form.selectionChange.keptResultsOne' | translate }}
            } @else {
              {{ 'testPlans.form.selectionChange.keptResults' | translate: { count: countedRuns() } }}
            }
          </div>
        }
        @if (added().length > 0) {
          <div>{{ 'testPlans.form.selectionChange.newOpen' | translate }}</div>
        }
      } @else {
        <div>{{ 'testPlans.form.selectionChange.noCounted' | translate }}</div>
      }
      @if (runningRun(); as run) {
        <div class="scd-text--warn">{{ 'testPlans.form.selectionChange.running' | translate: { key: run.key } }}</div>
      }
    }
    @if (reopensPlan()) {
      <div class="scd-text--info">{{ 'testPlans.form.selectionChange.reopens' | translate }}</div>
    }

    <label class="scd-reason">
      <span class="scd-reason__label">
        {{ 'testPlans.form.selectionChange.reasonLabel' | translate }}
        <span class="scd-reason__optional">{{ 'testPlans.form.selectionChange.reasonOptional' | translate }}</span>
      </span>
      <textarea
        #reasonField
        class="scd-reason__field"
        rows="3"
        data-testid="tp-change-selection-reason"
        [value]="reason()"
        [attr.maxlength]="maxReason"
        [placeholder]="
          (removed().length > 0
            ? 'testPlans.form.selectionChange.reasonPlaceholderRemoved'
            : 'testPlans.form.selectionChange.reasonPlaceholderAdded'
          ) | translate
        "
        (input)="reason.set(reasonField.value)"
      ></textarea>
      <span class="scd-reason__hint">{{ 'testPlans.form.selectionChange.reasonHint' | translate }}</span>
    </label>
  </div>
</app-confirm-dialog>
